import { FC } from 'react';

import Typography from '@mui/material/Typography';

const SubHeading: FC<{ subHeading: string }> = ({ subHeading }) => {
    return (
        <Typography color="#F18F34" fontSize="24px" lineHeight="34.3px" fontWeight="500">
            {subHeading}
        </Typography>
    );
};

export default SubHeading;
